<template>
  <div class="detail d-md-flex">
    <div class="pic position-relative">
      <img :src="info.picture" class="w-100 h-100 object-fit-cover">
      <div class="title text-white p-4 p-xl-5">
        <h4 class="mb-0">{{info.name}}</h4>
        <p class="mt-1">{{info.title}}</p>
      </div>
    </div>
    <div class="text px-4 px-lg-5 py-5 lh-lg">
      <div class="p-lg-4">
          <p v-html="info.introduce"></p>
          <div class="mt-4 mt-lg-5" v-if="info.awards">
            <h6 class="text-uppercase fw-bold">Credentials</h6>
            <ul>
              <li class="d-flex" v-for="(item,index) in info.awards" :key="index">
                <span>{{item.year}}</span>
                <p class="ps-3">{{item.content}}</p>
              </li>
            </ul>
          </div>
          <div class="mt-4 mt-lg-5" v-if="info.speaking">
            <h6 class="text-uppercase fw-bold">Speaking</h6>
            <p>To inquire about Chim Lim's public speaking schedule and for booking,kindly contact</p>
            <div class="d-flex mt-2 mt-lg-3">
              <a href="https://twitter.com/fosaltd" target="_blank" class="contactBtn rounded-3 p-2 p-lg-3 d-flex justify-content-center align-items-center float-start">
                <img src="/static/images/twitterLogo.png" height="25">
              </a>
              <a href="https://www.instagram.com/lim.c.meng.75/" target="_blank" class="contactBtn rounded-3 p-2 p-lg-3 d-flex justify-content-center align-items-center float-start ms-2">
                <i class="bi bi-instagram fs-2 lh-1 time01"></i>
              </a>
              <a href="https://chimmlim.wordpress.com/" target="_blank" class="contactBtn rounded-3 p-2 p-lg-3 d-flex justify-content-center align-items-center float-start ms-2">
                <i class="bi bi-wordpress fs-2 lh-1 time01"></i>
              </a>

            </div>
            
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios-auth'
export default {
  name: 'peopleDetail',
  data () {
    return {
      id:this.$route.params.id,
      info:[]
    }
  },
  created(){
    axios.get('/about.json')
      .then( res => {
        return res.data
      })
      .then( response => {
        if(response.code == 0){
          this.info = response.data.people[this.id]
        }
      })


    
  },
  computed:{  

  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .detail .title{ position: absolute; left: 0; right: 0; bottom: 0;}
  .detail .title p{ color: rgba(255, 255, 255, .7);}
  .detail .text{ flex: 1;}
  .detail li p{ flex: 1;}
  .contactBtn{ background-color: #d9d9d9; color: #000; min-width: 50px;}

  @media (min-width: 576px) {
    
  }

  @media (min-width: 768px) {
    .detail .pic{ width: 550px; height: calc(100vh - 60px);}
    .detail .text{ height: calc(100vh - 60px); overflow-y: auto;}
  }

  @media (min-width: 992px) {
    .detail .pic{ height: calc(100vh - 80px);}
    .detail .text{ height: calc(100vh - 80px);}
    .detail .title h4{ font-size: 2.5vw;}
    .contactBtn:hover{ opacity: .9;}
    .contactBtn img{ height: 32px;}
  }

  @media (min-width: 1200px) {
    .detail .text{ padding: 100px !important;}
  }

  @media (min-width: 1400px) {
    

  }
</style>



// WEBPACK FOOTER //
// src/components/about/Detail.vue